import React, { useEffect, useState, useContext } from 'react'
import Popup from '../../Product/components/organisms/Popup'
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'
import { setKey } from 'react-geocode'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'
import './LocationHours.css'
import schedulePickupContext from '../../Product/context/plugin/schedulePickup/schedulePickupContext'
import productContext from '../../Product/context/product/productContext'

const LocationHours = (props) => {
    const { getAllTimings, all_timings } = useContext(schedulePickupContext)
    const { productLocalState } = useContext(productContext)
    const [allLocations, setAllLocations] = useState([])
    const [sourceLocations, setSourceLocations] = useState([])

    const getCenterForGridMap = (loc) => {
        return { lat: loc.lat, lng: loc.lng, zoom: 8 }
    }

    useEffect(() => {
        if (
            all_timings &&
            Array.isArray(all_timings.all_locations) &&
            all_timings.all_locations.length > 0 &&
            Array.isArray(all_timings.all_locations[0].range_key) &&
            all_timings.all_locations[0].range_key.length > 0
        ) {
            setAllLocations(all_timings.all_locations.map((location) => location.range_key[0]))
        }
    }, [all_timings])

    const checkBidShopTheme = document.body.className == 'liquidationTwo bidShop'

    const locationsStatic = [
        {
            lat: checkBidShopTheme ? 40.8883931 : 29.7120471,
            lng: checkBidShopTheme ? -80.6939643 : -95.5167979,
            name: checkBidShopTheme ? 'Butler, PA' : 'Houston TX',
            address: checkBidShopTheme
                ? '📍1980 N Main St. Ext. Butler, PA 16001'
                : '102 Shaver St, Pasadena, TX 77506',
            redirectionURL: checkBidShopTheme
                ? global.storeConfigration?.warehouse_redirection_url?.value
                : 'https://maps.app.goo.gl/FMMh2dQ5JsMRryk58',
            openHours: checkBidShopTheme
                ? [
                      { day: 'Tuesday-Friday', hours: '12:00pm - 6:00pm' },
                      { day: 'Saturday', hours: '11:00am - 3:00pm' },
                  ]
                : [
                      { day: 'Monday', hours: '09:30 am - 07:00 pm' },
                      { day: 'Tuesday', hours: '09:30 am - 07:00 pm' },
                      { day: 'Wednesday', hours: '09:30 am - 07:00 pm' },
                      { day: 'Thurdsay', hours: '09:30 am - 07:00 pm' },
                      { day: 'Friday', hours: '09:30 am - 07:00 pm' },
                      { day: 'Saturday', hours: '09:30 am - 07:00 pm' },
                      { day: 'Sunday', hours: 'Closed' },
                  ],
        },
    ]

    const style = {
        height: '350px',
        maxWidth: '500px',
        width: '100%',
        border: '10px solid #fff',
        margin: '10px 0 0 auto',
    }

    const handleLocation = (redirectionURL, locationsObj) => {
        if (redirectionURL) {
            window.open(redirectionURL, '_blank')
            return
        }
        const mapAddress = `${locationsObj?.business_address1 || locationsObj?.address || ''} ${
            locationsObj?.business_address2 || ''
        },${locationsObj?.business_city || ''}, ${locationsObj?.business_state || ''} ${
            locationsObj?.business_zip || ''
        },United states`
        const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            mapAddress,
        )}`
        window.open(mapUrl, '_blank', 'noreferrer')
    }

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyANJvSnxieaGRhq_Ndt1Fe4MKDkDYE-SOM',
    })

    setKey('AIzaSyANJvSnxieaGRhq_Ndt1Fe4MKDkDYE-SOM')

    const [map, setMap] = useState(null)

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    // Utilities
    const weekdaysOrderFull = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
    ]

    const formatTime = (time) => {
        if (!time) return ''
        const t = time.trim()
        // expected "9:00 AM" or "09:00 AM". Normalize to "h:mmam/pm" (no space)
        const parts = t.split(' ')
        let timePart = parts[0]
        let period = parts[1] || ''
        // If period attached like "9:00AM"
        if (!period) {
            const m = timePart.match(/(AM|PM|am|pm)$/)
            if (m) {
                period = m[0]
                timePart = timePart.replace(m[0], '')
            }
        }
        const [hoursStr = '0', minutesStr = '00'] = timePart.split(':')
        const hours = parseInt(hoursStr, 10)
        const minutes = (minutesStr || '00').padStart(2, '0')
        const periodLower = period ? period.toLowerCase() : ''
        return `${hours}:${minutes}${periodLower}`
    }

    // Convert schedule -> rows with dayLabel (full names or "X-Y") and hoursLabel like "12:00pm - 6:00pm"
    const buildHoursRowsFromSchedule = (locationsProp) => {
        const schedule = locationsProp?.general || []
        const daysWithSameHours = {}

        schedule.forEach((day) => {
            if (day.Status === 'Open' && Array.isArray(day.Day_Times) && day.Day_Times.length > 0) {
                const timeKey = `${day.Day_Times[0].start_time}-${day.Day_Times[0].end_time}`
                if (!daysWithSameHours[timeKey]) daysWithSameHours[timeKey] = []
                daysWithSameHours[timeKey].push(day.Day)
            }
        })

        const rows = []

        Object.entries(daysWithSameHours).forEach(([timeKey, days]) => {
            const [startTime, endTime] = timeKey.split('-')
            const formattedStartTime = formatTime(startTime)
            const formattedEndTime = formatTime(endTime)
            const hoursLabel = `${formattedStartTime} - ${formattedEndTime}`

            const sortedDaysFull = weekdaysOrderFull.filter((day) => days.includes(day))

            if (sortedDaysFull.length === 0) return

            // group consecutive full-day names
            const consecutiveGroups = []
            let currentGroup = [sortedDaysFull[0]]

            for (let i = 1; i < sortedDaysFull.length; i++) {
                const prevIndex = weekdaysOrderFull.indexOf(sortedDaysFull[i - 1])
                const currentIndex = weekdaysOrderFull.indexOf(sortedDaysFull[i])
                if (currentIndex === prevIndex + 1) {
                    currentGroup.push(sortedDaysFull[i])
                } else {
                    consecutiveGroups.push(currentGroup)
                    currentGroup = [sortedDaysFull[i]]
                }
            }
            consecutiveGroups.push(currentGroup)

            consecutiveGroups.forEach((group) => {
                if (group.length > 1) {
                    rows.push({
                        dayLabel: `${group[0]}-${group[group.length - 1]}`,
                        hoursLabel,
                    })
                } else {
                    rows.push({
                        dayLabel: `${group[0]}`,
                        hoursLabel,
                    })
                }
            })
        })

        // closed days
        const closedDays = []
        schedule.forEach((day) => {
            if (day.Status !== 'Open') closedDays.push(day.Day)
        })
        if (closedDays.length > 0) {
            rows.push({
                dayLabel: 'Closed',
                hoursLabel: closedDays.join(' & '),
            })
        }

        return rows
    }

    // matching logic: compare selected globalLocation with location.business_state (not strict)
    const matchesSelectedLocation = (loc) => {
        const selected = productLocalState?.globalLocation
        if (!selected) return true // no selection -> allow
        const sel = String(selected).trim().toLowerCase()
        const stateVal = String(loc?.business_state || loc?.state || '')
            .trim()
            .toLowerCase()
        const cityVal = String(loc?.business_city || loc?.business_city_name || '')
            .trim()
            .toLowerCase()

        if (!sel) return true
        // match if equal or partial inclusion either way
        if (stateVal && (stateVal === sel || stateVal.includes(sel) || sel.includes(stateVal)))
            return true
        if (cityVal && (cityVal === sel || cityVal.includes(sel) || sel.includes(cityVal)))
            return true
        return false
    }

    // build sourceLocations when input data or selection changes
    useEffect(() => {
        const resolve = () => {
            let source = []
            if (props?.locations) {
                if (Array.isArray(props.locations)) source = [...props.locations]
                else source = [props.locations]
            } else if (Array.isArray(allLocations) && allLocations.length > 0) {
                source = [...allLocations]
            } else {
                source = [...locationsStatic]
            }

            // If there is a selected globalLocation, filter by it.
            if (productLocalState?.globalLocation) {
                const filtered = source.filter((loc) => matchesSelectedLocation(loc))
                if (filtered.length > 0) {
                    source = filtered
                } else {
                    // if nothing matched, keep original source (or choose first). Here: keep original source but prefer first element
                    source = [source[0]].filter(Boolean)
                }
            }

            setSourceLocations(source)
        }

        resolve()
    }, [props.locations, allLocations, productLocalState])

    const renderLocationCard = (locObj, index) => {
        const lat = locObj?.lat || locObj?.latitude || locationsStatic[0].lat
        const lng = locObj?.lng || locObj?.longitude || locationsStatic[0].lng
        const name = locObj?.name || locObj?.business_city || locationsStatic[0].name
        const address =
            locObj?.address ||
            (locObj?.business_address1
                ? `${locObj.business_address1}${
                      locObj.business_address2 ? ', ' + locObj.business_address2 : ''
                  }`
                : locationsStatic[0].address)
        const redirectionURL = locObj?.redirectionURL || locObj?.redirect_url || null

        const openHoursRows =
            Array.isArray(locObj?.openHours) && locObj.openHours.length > 0
                ? locObj.openHours.map((h) => ({ dayLabel: h.day, hoursLabel: h.hours }))
                : buildHoursRowsFromSchedule(locObj)

        return (
            <div
                className="location_hours_card"
                key={locObj?.range_key || locObj?.business_city || index}
            >
                {isLoaded ? (
                    <GoogleMap
                        mapContainerStyle={style}
                        mapView={true}
                        center={getCenterForGridMap({ lat, lng })}
                        zoom={8}
                        onUnmount={onUnmount}
                    >
                        <Marker
                            position={{ lat, lng }}
                            onClick={() => handleLocation(redirectionURL, locObj)}
                        />
                    </GoogleMap>
                ) : (
                    <div style={{ height: style.height, maxWidth: style.maxWidth }} />
                )}

                <div className="location_card_content">
                    <h4>{name}</h4>
                    <p>{address}</p>
                </div>

                <div className="location_hours_card_box">
                    <PrimaryButton
                        label="Get Direction"
                        onClick={() => handleLocation(redirectionURL, locObj)}
                    />
                    <ul className="hours_list">
                        <li className="hours_title">Location Hours</li>
                        <li className="hours_list_items">
                            {openHoursRows.map((r, i) => (
                                <div key={i}>
                                    <span>{r.dayLabel}:</span>
                                    <span>{r.hoursLabel}</span>
                                </div>
                            ))}
                        </li>
                    </ul>
                </div>
            </div>
        )
    }

    return (
        <Popup
            {...props}
            size="md"
            modalClass={`save-search-modal ${props.classNames}`}
            modaltitle={'Location & Hours'}
        >
            <>
                {global.storeDetails.site_id === 'AS0698' ||
                global.storeDetails.site_id === 'AS0575' ||
                checkBidShopTheme ? (
                    <>
                        {checkBidShopTheme ? (
                            <div className="location_hours_card_container">
                                {sourceLocations.map((loc, idx) => renderLocationCard(loc, idx))}
                            </div>
                        ) : (
                            <>
                                {isLoaded ? (
                                    <div className="location_hours_card_container">
                                        {locationsStatic.map((data, index) => (
                                            <div className="location_hours_card" key={index}>
                                                <GoogleMap
                                                    mapContainerStyle={style}
                                                    mapView={true}
                                                    center={getCenterForGridMap({
                                                        lat: data.lat,
                                                        lng: data.lng,
                                                    })}
                                                    zoom={8}
                                                    onUnmount={onUnmount}
                                                >
                                                    <Marker
                                                        position={{ lat: data.lat, lng: data.lng }}
                                                        onClick={() =>
                                                            handleLocation(
                                                                data.redirectionURL,
                                                                data,
                                                            )
                                                        }
                                                    />
                                                </GoogleMap>
                                                <div className="location_card_content">
                                                    <h4>{data.name}</h4>
                                                    <p>{data.address}</p>
                                                </div>
                                                <div className="location_hours_card_box">
                                                    <PrimaryButton
                                                        label="Get Direction"
                                                        onClick={() =>
                                                            handleLocation(
                                                                data.redirectionURL,
                                                                data,
                                                            )
                                                        }
                                                    />
                                                    <ul className="hours_list">
                                                        <li className="hours_title">
                                                            Location Hours
                                                        </li>
                                                        <li className="hours_list_items">
                                                            {data.openHours.map((d, i) => (
                                                                <div key={i}>
                                                                    <span>{d.day}:</span>
                                                                    <span>{d.hours}</span>
                                                                </div>
                                                            ))}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : null}
                            </>
                        )}
                    </>
                ) : null}
            </>
        </Popup>
    )
}

export default LocationHours
